import { useAtomValue } from 'jotai';
import { Outlet } from 'react-router';
import { hasBenchmarkAtom } from '@/modules/sentinel-workspace/benchmark/benchmark-state';
import SecondarySidebarLayout, { type SecondarySidebarItem } from './secondary-sidebar-layout';

const ITEMS: SecondarySidebarItem[] = [
  { label: 'Tickets', path: '/sentinel-workspace' },
  { label: 'Benchmark', path: '/sentinel-workspace/benchmark' },
];

/** The Sentinel sidebar, for Benchmark editors and the Sentinels of the selected account. Anyone else (and anyone when the
 * check fails) gets the page alone, as before Benchmark had a page of its own. Nothing renders until the check answers, so
 * the page mounts once, already in its final layout: adding the sidebar later would remount the ticket workspace. */
export default function SentinelLayout() {
  const hasBenchmark = useAtomValue(hasBenchmarkAtom);
  if (hasBenchmark === null) return null;
  if (!hasBenchmark) return <Outlet />;
  // Starts collapsed so the tickets get the width; opening it keeps it open across Tickets and Benchmark.
  return <SecondarySidebarLayout title='Sentinel' items={ITEMS} autoCollapsePaths={['/sentinel-workspace']} />;
}
